"use client"

/* eslint-disable react/no-unescaped-entities */
import { ShoppingCart } from "lucide-react"
import { forwardRef } from "react"
import { useMiniCartStore } from "../use-new-minicart-store"

interface MiniCartHeaderProps {
  grandTotal: any
  cartQuantity: number
}

export const MiniCartHeader = forwardRef<HTMLDivElement, MiniCartHeaderProps>(
  ({ grandTotal, cartQuantity }, ref) => {
    const headerIcon = useMiniCartStore((state) => state?.headerIcon)
    const headerText = useMiniCartStore((state) => state?.headerText)

    const getPromotionalMessage = () => {
      if (cartQuantity === 1) {
        return (
          <span className="font-sans text-sm leading-[1.4] text-title">
            <span>
              Buy 1 More &{" "}
              <span className="font-[700] text-primary">Save 15%</span>! CODE:
            </span>
            &nbsp;
            <span className="font-[700] text-primary">KY15</span>
          </span>
        )
      } else if (cartQuantity >= 2) {
        return (
          <span className="font-sans text-sm leading-[1.4] text-title">
            <span className="font-[700] text-primary">15%</span>&nbsp;Off
            Unlocked! Use&nbsp;
            <span className="font-[700] text-primary">KY15</span>&nbsp;at
            checkout!
          </span>
        )
      }

      return null
    }

    return (
      <div
        className="mx-[24px] border-b-1 border-solid border-b-[#EFEFEF] py-[20px]"
        ref={ref}
      >
        <div className="text-left font-poppins text-[26px] font-[600] leading-[1.4] text-title">
          {headerText}
        </div>

        <div className="mt-[5px]">
          <div className="text-left">{getPromotionalMessage()}</div>
        </div>
      </div>
    )
  }
)

MiniCartHeader.displayName = "MiniCartHeader"
